import * as actions from './actions'

const PickupGoogleSheetsStore = {
  state: {},
  getters: {},
  mutations: {},
  actions
}

export default PickupGoogleSheetsStore
